<template>
    <div class="wrap">
      <header class="header">
         <div class="header__container">
            <div class="header__row">
               <a href="/myprotein-result" class="prev prev--white" aria-label="이전"></a>
            </div>
         </div>
      </header>

      <div class="contents">
         <div class="contents__contents contents__contents--overlap">
            <div class="result-detail">
               <p class="result-detail__caption">알쏭달쏭 단백질 퀴즈 정답 결과</p>
               
			   <div class="result-detail__sum">
                  <div>
                     <p>정답</p>
                     <span class="result-detail__flag">{{this.correct}}개</span>
                  </div>
                  <div>
                     <p>오답</p>
                     <span class="result-detail__flag result-detail__flag--secondary">{{this.incorrect}}개</span>
                  </div>
               </div>

               <div class="accordion">
				<!-- 알쏭달쏭 1번 문제 -->
				<button @click="confirmMyAnswerResult('Q1')" type="button" role="heading" id="accoBtn01" class="accordion__header" aria-level="3" aria-controls="accoPanel01" aria-expanded="true">
					<span class="accordion__title">
					<em>Q1.</em>
					단백질은 운동하는 사람에게만 중요한 영양소이다?
					</span>
					<span class="result-detail__flag" v-if="this.quizResult.Q1 === 'X'">정답</span>
					<span class="result-detail__flag result-detail__flag--secondary" v-else>오답</span>

					<i class="accordion__ico" :class="{'rotate-down' : this.isOpen.Q1 }" aria-hidden="true"></i>
				</button>
				

                <div v-if="this.isOpen.Q1" role="region" id="accoPanel01" class="accordion__panel" aria-labelledby="accoBtn01" aria-hidden="true">
					<div class="accordion__inner">
						<div v-if="this.quizResult.Q1 === 'X'" class="result-detail__wrote">
							답:
							<i class="result-detail__shape result-detail__shape--x"></i>
						</div>

						<div v-else class="result-detail__wrote">
							답:
							<i class="result-detail__shape result-detail__shape--o"></i>
							<div class="result-detail__wrong">
								<i class="result-detail__shape result-detail__shape--x"></i>
							</div>
						</div>
                        <p class="desc">
							단백질은 근육, 손톱, 머리카락 등 신체 조직을 구성하고 에너지를 합성하며, 세포 구축과 면역 시스템 강화, 호르몬, 효소 및 헤모글로빈 생성, 그리고 체내 화학 반응 등의 주요한 기능을 수행하는 데 필수적인 영양소로 우리 몸의 16% 를 차지하고 있습니다.  건강한 삶을 원한다면 단백질은 남녀노소 모두에게 필수인 영양소입니다.
                        </p>
                        <p class="etc">*출처: Hoffman, Jay R., and Michael J. Falvo. “Protein-which is best?.” Journal of sports science & medicine 3.3 (2004): 118.Duda, K., Majerczak, J., Nieckarz, Z., Heymsfield, S. B., & Zoladz, J. A. (2019). Human Body Composition and Muscle Mass. Muscle and Exercise Physiology, 3-26.</p>
                     </div>
				</div>
                 
				<!-- 알쏭달쏭 2번 문제 -->
				<button @click="confirmMyAnswerResult('Q2')" type="button" role="heading" id="accoBtn02" class="accordion__header" aria-level="3" aria-controls="accoPanel02" aria-expanded="true">
                     <span class="accordion__title">
                        <em>Q2.</em>
                        단백질, 한번에 많이 먹을수록 좋다?
                     </span>
					 <span class="result-detail__flag" v-if="this.quizResult.Q2 === 'X'">정답</span>
                     <span class="result-detail__flag result-detail__flag--secondary" v-else>오답</span>
                     <i class="accordion__ico" :class="{'rotate-down' : this.isOpen.Q2 }" aria-hidden="true"></i>
                  </button>

				<div v-if="this.isOpen.Q2" role="region" id="accoPanel02" class="accordion__panel" aria-labelledby="accoBtn02" aria-hidden="true">
					<div class="accordion__inner">

					<div v-if="this.quizResult.Q2 === 'X' " class="result-detail__wrote">
						답:
						<i class="result-detail__shape result-detail__shape--x"></i>
					</div>

					<div v-else class="result-detail__wrote">
						답:
						<i class="result-detail__shape result-detail__shape--o"></i>
						<div class="result-detail__wrong">
							<i class="result-detail__shape result-detail__shape--x"></i>
						</div>
					</div>

					<p class="desc">근육은 한번 합성을 시작하면 한번에 최대 30g의 단백질만을 사용합니다. 근육 합성 효율을 생각한다면 단백질 하루 권장 섭취량을 3시간 이상의 간격을 두고 균등하게 나누어 섭취하는 것이 좋습니다.</p>
					<p class="etc">*출처: Symons, T. Brock, et al. “A moderate serving of high-quality protein maximally stimulates skeletal muscle protein synthesis in young and elderly subjects.” J Am Diet Assoc 109.9 (2009): 1582-1586. Moore, Daniel R., et al. “Daytime pattern of post-exercise protein intake affects whole-body protein turnover in resistance-trained males.” Nutrition & metabolism 9.1 (2012): 1-5.</p>
					</div>
				</div>	
                
				<!-- 알쏭달쏭 3번 문제 -->
				<button @click="confirmMyAnswerResult('Q3')" type="button" role="heading" id="accoBtn03" class="accordion__header" aria-level="3" aria-controls="accoPanel03" aria-expanded="true">
                     <span class="accordion__title">
                        <em>Q3.</em>
                        나이가 들수록 체내 단백질이 자연스럽게 줄어든다?
                     </span>
					 <span class="result-detail__flag" v-if="this.quizResult.Q3 === 'O'">정답</span>
                     <span class="result-detail__flag result-detail__flag--secondary" v-else>오답</span>
                     <i class="accordion__ico" :class="{'rotate-down' : this.isOpen.Q3 }" aria-hidden="true"></i>
				</button>

				<div v-if="this.isOpen.Q3" role="region" id="accoPanel03" class="accordion__panel" aria-labelledby="accoBtn03" aria-hidden="true">
					<div class="accordion__inner">

						<div v-if="this.quizResult.Q3 === 'O' " class="result-detail__wrote">
                           답:
							<i class="result-detail__shape result-detail__shape--o"></i>
                        </div>

						<div v-else class="result-detail__wrote">
                           답:
						   <i class="result-detail__shape result-detail__shape--x"></i>
						   <div class="result-detail__wrong">
								<i class="result-detail__shape result-detail__shape--o"></i>
							</div>
                        </div>

                        <p class="desc">체내 단백질은 나이가 들어감에 따라 자연스럽게 감소하여 65세 이상 노인의 경우 20대에 비해 총 신체 단백질이 약 14% 감소합니다. </p>
                        <p class="etc">*출처: Hardman, Shalene E. The Effects of Aging on Skeletal Muscle AMPK Activation and an Analysis of Chronic AICAR Treatment on the Aging Phenotype. Diss. Brigham Young University, 2014.</p>
					</div>
				</div>
               
				<!-- 알쏭달쏭 4번 문제 -->
				<button @click="confirmMyAnswerResult('Q4')" type="button" role="heading" id="accoBtn04" class="accordion__header" aria-level="3" aria-controls="accoPanel04" aria-expanded="false">
                     <span class="accordion__title">
                        <em>Q4.</em>
                        운동만 열심히 하면 근육이 늘어난다?
                     </span>
                     <span class="result-detail__flag" v-if="this.quizResult.Q4 === 'X'">정답</span>
                     <span class="result-detail__flag result-detail__flag--secondary" v-else>오답</span>
                     <i class="accordion__ico" :class="{'rotate-down' : this.isOpen.Q4 }" aria-hidden="true"></i>
				</button>

				<div :style=" {display : this.isOpen.Q4 ? 'block' : 'none'}" v-if="this.isOpen.Q4" role="region" id="accoPanel04" class="accordion__panel" aria-labelledby="accoBtn04" aria-hidden="true">
                     <div class="accordion__inner">
						<div v-if="this.quizResult.Q4 === 'X' " class="result-detail__wrote">
                           답:
                           <i class="result-detail__shape result-detail__shape--x"></i>
                        </div>

						<div v-else class="result-detail__wrote">
                           답:
						   <i class="result-detail__shape result-detail__shape--o"></i>
						   <div class="result-detail__wrong">
							   <i class="result-detail__shape result-detail__shape--x"></i>
							</div>
                        </div>
						
                        <p class="desc">아닙니다. 근육 형성을 위해서는 운동과 함께 단백질 보충이 같이 이뤄져야합니다. 근육은 운동을 통해 근육에 자극을 주어 근섬유에 상처를 만들고, 이후 충분한 휴식과 영양 섭취를 통해 근섬유의 상처가 회복되는 과정에서 생성 됩니다. 효율적인 근육 생성을 위해 체중 1kg 당 1.5g의 단백질 섭취와 함께 주 3회 이상 근력 운동 꼭 기억해주세요!</p>
                        <p class="etc">*출처: Am J Physiol Endocrinol Metab. 2015 Jan 1;308(1):E21-8. Morton RW et al. A systematic review, meta-analysis and meta-regression of the effect of protein supplementation on resistance training-induced gains in muscle mass and strength in healthy adults. Br J Sports Med. 2018 Mar;52(6):376-384. Chargé SB, Rudnicki MA. Cellular and molecular regulation of muscle regeneration. Physiol Rev. 2004 Jan;84(1):209-38.</p>
                     </div>
				</div>

				  <!-- 5번 문항 -->
				<button @click="confirmMyAnswerResult('Q5')" type="button" role="heading" id="accoBtn05" class="accordion__header" aria-level="3" aria-controls="accoPanel05" aria-expanded="false">
                     <span class="accordion__title">
                        <em>Q5.</em>
                        다음 중 좋은 단백질 제품을 고르는 기준 으로 맞는 내용을 모두 골라주세요.
                     </span>
                     <span class="result-detail__flag" v-if="this.Q5">정답</span>
                     <span class="result-detail__flag result-detail__flag--secondary" v-else>오답</span>
                     <i class="accordion__ico" :class="{'rotate-down' : this.isOpen.Q5 }" aria-hidden="true"></i>
				</button>

				<div :style=" {display : this.isOpen.Q5 ? 'block' : 'none'}" v-if="this.isOpen.Q5" role="region" id="accoPanel05" class="accordion__panel" aria-labelledby="accoBtn05" aria-hidden="true">
                     <div class="accordion__inner">
						
						<div v-if="this.Q5" class="result-detail__wrote">
                           답:{{this.correctList.Q5[0]}} 번 {{this.correctList.Q5[1]}} 번 {{this.correctList.Q5[2]}} 번
                        </div>

						<div v-else class="result-detail__wrote">
							답: 
							<span class="wrong-span" v-for="i in this.quizResult.Q5" :key="i">
								<!-- {{this.quizResult.Q5[0]}} 번 {{this.quizResult.Q5[1]}} 번 {{this.quizResult.Q5[2]}}  -->
								{{i}}번
							</span>
						   <div class="result-detail__wrong">
							   {{this.correctList.Q5[0]}} 번 {{this.correctList.Q5[1]}} 번 {{this.correctList.Q5[2]}} 번 
							</div>
                        </div>
                        <p class="desc">[좋은 단백질을 구매하는법] <br> ° 식약처 인증 건강기능식품 마크를 확인해요. <br>° 아미노산 스코어가 100이상인 높은 영양가 제품을 선택해요. <br>° 필수 및 비필수 아미노산 20가지가 모두 포함되었는지 확인해요. <br>° 합성착향료 없이 최소한의 원재료만으로 제대로 만든 제품을 선택해요.</p>
                     </div> 
				</div>
				  
				  <!-- 6번 문항 -->
				<button @click="confirmMyAnswerResult('Q6')" type="button" role="heading" id="accoBtn06" class="accordion__header" aria-level="3" aria-controls="accoPanel05" aria-expanded="false">
                     <span class="accordion__title">
                        <em>Q6.</em>
						우리 몸에 반드시 필요한
                        필수 및 비필수 아미노산은<br>
                        총 ____ 종이다.
                     </span>
                     <span class="result-detail__flag" v-if="this.quizResult.Q6 === '3'">정답</span>
                     <span class="result-detail__flag result-detail__flag--secondary" v-else>오답</span>
                     <i class="accordion__ico" :class="{'rotate-down' : this.isOpen.Q6 }" aria-hidden="true"></i>
				</button>

				<div :style=" {display : this.isOpen.Q6 ? 'block' : 'none'}" role="region" id="accoPanel06" class="accordion__panel" aria-labelledby="accoBtn06" aria-hidden="true">
                     <div class="accordion__inner">
						
						<div v-if="this.quizResult.Q6 === '3'" class="result-detail__wrote">
                           답:{{this.correctList.Q6}} 번
                        </div>

						<div v-else class="result-detail__wrote">
							답: <span class="wrong-span">{{this.quizResult.Q6}}</span> 번
						   <div class="result-detail__wrong">
							   {{this.correctList.Q6}} 번 
							</div>
                        </div>
                        <p class="desc">체내 단백질 형성을 위해서는 총 20종의 아미노산이 필요합니다. 이 중 11종은 몸에서 합성되는 '비필수 아미노산'이며, 9종은 몸에서 합성되지 않아 식품으로 섭취해야 하는 '필수 아미노산' 입니다. 9가지 필수 아미노산이 모두 포함되어 있는 단백질을 완전 단백질이라고 하며, 단백질 제품을 선택 할 땐, 100% 완전 단백질인지 품질 기준을 확인하는 것이 매우 중요합니다.</p>
                        <p class="etc">*출처: Scientific opinion on dietary reference values for protein. EFSA Journal 2012; 10(2):2557 Westerterp-Plantenga, M. S., Nieuwenhuizen, A., Tomé, D., Soenen, S., & Westerterp, K. R. (2009). Dietary Protein, Weight Loss, and Weight Maintenance. Annual Review of Nutrition, 29(1), 21–41.</p>
                     </div>
				</div>

				  <!-- 7번 문항 -->
				<button @click="confirmMyAnswerResult('Q7')" type="button" role="heading" id="accoBtn05" class="accordion__header" aria-level="3" aria-controls="accoPanel04" aria-expanded="false">
                     <span class="accordion__title">
                        <em>Q7.</em>
                        단백질 섭취 골든타임은<br>
                        운동 직후 ____ 이내이다.
                     </span>
                     <span class="result-detail__flag" v-if="this.quizResult.Q7 === '2'">정답</span>
                     <span class="result-detail__flag result-detail__flag--secondary" v-else>오답</span>
                     <i class="accordion__ico" :class="{'rotate-down' : this.isOpen.Q7 }" aria-hidden="true"></i>
				</button>

				<div :style=" {display : this.isOpen.Q7 ? 'block' : 'none'}" role="region" id="accoPanel05" class="accordion__panel" aria-labelledby="accoBtn05" aria-hidden="true">
                     <div class="accordion__inner">
						<div v-if="this.quizResult.Q7 === '2'" class="result-detail__wrote">
                           답:{{this.correctList.Q7}} 번
                        </div>

						<div v-else class="result-detail__wrote">
							답: <span class="wrong-span">{{this.quizResult.Q7}}</span> 번
						   <div class="result-detail__wrong">
							   {{this.correctList.Q7}} 번 
							</div>
                        </div>
						
                        <p class="desc">단백질 섭취 골든타임은 기상직후/아침, 점심, 저녁, 운동 전/후 입니다. 특히 운동 직후 45분 이내 단백질을 섭취할 경우, 손상된 근육 단백질을 회복시키고 근육 내 글리코겐을 저장하여 근육 성장에 도움이 됩니다. 운동 후 잊지말고 단백질 꼭 챙겨주세요!</p>
                        <p class="etc">*출처 : Paddon-Jones D, Rasmussen BB. Dietary protein recommendations and the prevention of sarcopenia. Curr Opin Clin Nutr Metab Care. 2009 Jan;12(1):86-90. Schoenfeld, Brad Jon, et al. "Pre-versus post-exercise protein intake has similar effects on muscular adaptations." PeerJ 5 (2017): e2825. Ivy, J. L., & Ferguson-Stegall, L. M. (2013). Nutrient Timing. American Journal of Lifestyle Medicine, 8(4), 246–259.</p>
                     </div>
                  </div>

				  <!-- 8번 문항-->
				  <button @click="confirmMyAnswerResult('Q8')" type="button" role="heading" id="accoBtn05" class="accordion__header" aria-level="3" aria-controls="accoPanel04" aria-expanded="false">
                     <span class="accordion__title">
                        <em>Q8.</em>
                        다음 중 단백질의 공식 기능이<br>
						아닌 것 은 무엇일까요?<br>
                        <!-- <span class="line-highlight">아닌 것</span>은 무엇일까요? -->
                     </span>
                     <span class="result-detail__flag" v-if="this.quizResult.Q8 === '4'">정답</span>
                     <span class="result-detail__flag result-detail__flag--secondary" v-else>오답</span>
                     <i class="accordion__ico" :class="{'rotate-down' : this.isOpen.Q8 }" aria-hidden="true"></i>
				</button>

				<div :style=" {display : this.isOpen.Q8 ? 'block' : 'none'}" role="region" id="accoPanel05" class="accordion__panel" aria-labelledby="accoBtn04" aria-hidden="true">
                     <div class="accordion__inner">

						<div v-if="this.quizResult.Q8 === '4'" class="result-detail__wrote">
                           답:{{this.correctList.Q8}} 번
                        </div>

						<div v-else class="result-detail__wrote">
							답: <span class="wrong-span">{{this.quizResult.Q8}}</span> 번
						   <div class="result-detail__wrong">
							   {{this.correctList.Q8}} 번 
							</div>
                        </div>
                        <p class="desc">단백질은 신체 조직, 피부, 머리카락, 호르몬, 뼈, 효소  등 우리 몸을 구성하고 몸 곳곳에 비타민 및 무기질 등 영양소를 운반해 주고 저장함으로써 인체가 발달하고 성장하는 것을 도와주는 중요한 영양소입니다. 우리 몸 속 많은 역할을 하는 단백질, 왜 챙겨야 하는지 아시겠죠? <br> [단백질 공식 기능] <br> ① 근육, 결합조직 등 신체조직의 구성성분 <br> ② 효소, 호르몬, 항체의 구성에 필요 <br> ③ 체내 필수 영양성분이나 활성물질의 운반과 저장에 필요 <br> ④ 체액, 산-염기의 균형 유지에 필요 <br> ⑤ 에너지, 포도당, 지질의 합성에 필요</p>
						<p class="etc">*출처:Hoffman, Jay R., and Michael J. Falvo. "Protein–which is best?." Journal of sports science & medicine 3.3 (2004): 118. Hashimoto A, Kambe T. Mg, Zn and Cu Transport Proteins: A Brief Overview from Physiological and Molecular Perspectives. J Nutr Sci Vitaminol (Tokyo). 2015;61 Suppl:S116-8. Reboul, E., & Borel, P. (2011). Proteins involved in uptake, intracellular transport and basolateral secretion of fat-soluble vitamins and carotenoids by mammalian enterocytes. Progress in lipid research, 50(4), 388–402.</p>
					</div>
				</div>

               </div> <!-- End of  accordion -->

            </div>
         </div>
      </div>
   </div>
</template>

<script>

export default {

   name : 'myprotein-answer-result',
   data () {
      return {

         quizResult : {
			Q1 : 'X',
            Q2 : 'X',
            Q3 : 'O',
            Q4 : 'X',
			Q5 : '',
			Q6 : '3',
			Q7 : '2',
			Q8 : '4'
         },
         correct : 0, // 정답 수

         // 정답 리스트
         correctList : {
            Q1 : 'X',
            Q2 : 'X',
            Q3 : 'O',
            Q4 : 'X',
			Q5 : ['1','3','4'],
			Q6 : '3',
			Q7 : '2',
			Q8 : '4'
         },
         incorrect : 0, // 오답 수
		 Q5 : false,
		 
		 // 정답결과 on/off
		 isOpen : {
			Q1 : false,
			Q2 : false,
			Q3 : false,
			Q4 : false,
			Q5 : false,
			Q6 : false,
			Q7 : false,
			Q8 : false
		 }

      }
   },
   methods : {

	// 답변결과확인
	confirmMyAnswerResult (e) {
		switch(e) {
			case 'Q1':
				this.isOpen.Q1 = !this.isOpen.Q1
				break
			case 'Q2':
				this.isOpen.Q2 = !this.isOpen.Q2
				break
			case 'Q3':
				this.isOpen.Q3 = !this.isOpen.Q3
				break
			case 'Q4':
				this.isOpen.Q4 = !this.isOpen.Q4
				break
			case 'Q5':
				this.isOpen.Q5 = !this.isOpen.Q5
				break
			case 'Q6':
				this.isOpen.Q6 = !this.isOpen.Q6
				break
			case 'Q7':
				this.isOpen.Q7 = !this.isOpen.Q7
				break
			case 'Q8':
				this.isOpen.Q8 = !this.isOpen.Q8
				break
		}
	}
	
   },
   mounted () {
	this.quizResult.Q1 = this.$route.params.data.Q1
	this.quizResult.Q2 = this.$route.params.data.Q2
	this.quizResult.Q3 = this.$route.params.data.Q3
	this.quizResult.Q4 = this.$route.params.data.Q4
	this.quizResult.Q5 = this.$route.params.data.Q5
	this.quizResult.Q6 = this.$route.params.data.Q6
	this.quizResult.Q7 = this.$route.params.data.Q7
	this.quizResult.Q8 = this.$route.params.data.Q8
	
	for (let i in this.correctList) {

		if (Array.isArray(this.correctList[i])) {

			// Q5 Array --> Sort 후 비교시작
			let sortCorrectList = this.correctList[i].sort()
			let sortUserAnsList = this.quizResult[i].sort()

			if (sortCorrectList.every((value , index ) => value === sortUserAnsList[index])) {
				this.Q5 = true
				++this.correct;
			}else {
				this.incorrect ++;
			}
		} else {
			// Single Object 비교
			if (this.correctList[i] === this.quizResult[i]) {
				this.correct ++;
			}else {
				this.incorrect ++
			}
		}

	}
	}
}
</script>

<style>
@import "./assets/css/amway.css";

.rotate-down {
	transform: rotate(-90deg) !important
}
.accordion__ico {
	transform: rotate(-270deg);
}
.wrong-span {
	text-decoration: line-through;
    text-decoration-color: red;
    text-decoration-thickness: 1.8px;
}
</style>


// WEBPACK FOOTER //
// src/views/myprotein-test/myproteinQuizAnswerResult.vue